import styled from '@emotion/styled';
import { getProviderInstructions } from '../utils/getProviderInstructions';

const ListWrapper = styled.div`
	border: 1px solid rgba(215, 215, 215, 1);
	padding: 16px;
	border-radius: 24px;
`;
const List = styled.ol`
	margin: 0 0 8px;
	padding-left: 16px;
`;
const ListItem = styled.li`
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	margin: 0;
`;
const ListText = styled.p`
	//styleName: Desktop/Body S;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	margin: 0;
`;

type HowToPayListProps = {
	providerCode?: string;
};

const HowToPayList = ({ providerCode }: HowToPayListProps) => {
	const instructions = getProviderInstructions(providerCode);

	return (
		<ListWrapper>
			<List>
				{instructions.steps.map((text, index) => (
					<ListItem key={index}>{text}</ListItem>
				))}
			</List>
			<ListText>{instructions.tip}</ListText>
		</ListWrapper>
	);
};
export default HowToPayList;
